import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { Divider, Grid, Typography } from '@material-ui/core';
import isNull from 'lodash/isNull';
import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
import { ADGMImage, ADGMItemDetails } from 'aurora-components';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import moment from 'moment';
import messages from 'aurora-translations';
import { injectIntl } from 'react-intl';
import styles from './styles';

function LegalNotificationDetails({ classes, legalNotices, application, handleChange, isEditable, intl }) {
  if (isEmpty(legalNotices) && !isEditable) return null;
  const secondTime = application?.legalNotices?.length > 0;
  const SECTION_FIELDS = useMemo(() => {
    return [
      {
        fields: [
          {
            name: 'noticeReason',
            type: 'dropdown',
            label: keyEmptyCheck('select_notice_reason'),
            placeholder: intl.formatMessage({ ...messages.select_an_option }),
            value: application?.noticeReason,
            options: [
              {
                label: keyEmptyCheck('THREE_UNCAPTURED_PAYMENTS'),
                value: 'THREE_UNCAPTURED_PAYMENTS',
              },
              { label: keyEmptyCheck('THIRTY_PERCENT_NOT_PAID'), value: 'THIRTY_PERCENT_NOT_PAID' },
            ],
            onChange: (name, dataValue) => handleChange({ noticeReason: dataValue?.value || null }),
            required: true,
            colSpace: 4,
            disabled: secondTime,
          },
          {
            name: 'noticeDate',
            type: 'date',
            upperLimit: new Date(new Date().getTime()).setDate(new Date().getDate()),
            date: moment(application?.noticeDate).isValid() ? moment(application?.noticeDate).format('YYYY-MM-DD') : '',
            onChange: date => handleChange({ noticeDate: moment(date).format('YYYY-MM-DD') }),
            dateComponentProps: {
              handleInputChange: date => {
                if (!isNull(date)) {
                  handleChange({
                    noticeDate: moment(date).format('YYYY-MM-DD'),
                  });
                }
              },
              required: true,
              label: keyEmptyCheck('notice_notification_date'),
              placeholder: intl.formatMessage({ ...messages.DD_MM_YY }),
              value: moment(application?.noticeDate).isValid()
                ? moment(application?.noticeDate).format('DD/MM/YYYY')
                : '',
              autoComplete: 'off',
              endAdornment: (
                <ADGMImage name='calendorIcon.svg' alt='calendar' className={classes.calendarTextfieldImage} />
              ),
              disabled: false,
            },
            colSpace: 4,
          },
        ],
      },
    ];
  }, [application]);
  return isEditable ? (
    <ADGMPanelInputsGeneratorBody
      bodyStyle={classes.containerPadding}
      sections={SECTION_FIELDS}
      isEditable={isEditable}
    />
  ) : (
    <div className={classes.container}>
      <Typography variant='h6' className={classes.titleHead}>
        {keyEmptyCheck('notification_details')}
      </Typography>
      <div className={classNames(classes.card, classes.innerContainer)}>
        {legalNotices?.map((notice, index) => (
          <>
            {legalNotices?.length > 1 && (
              <>
                <Typography variant='h6' className={classes.titleHead}>
                  {keyEmptyCheck('legal_notice_numbering', { num: index + 1 })}
                </Typography>
                <Divider />
              </>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <ADGMItemDetails label={keyEmptyCheck('notice_reason')} value={keyEmptyCheck(notice?.noticeReason)} />
              </Grid>
              <Grid item xs={12} md={3}>
                <ADGMItemDetails label={keyEmptyCheck('developer_notice_date')} value={notice?.developerNoticeDate} />
              </Grid>
              <Grid item xs={12} md={3}>
                <ADGMItemDetails label={keyEmptyCheck('legal_notice_date')} value={notice?.noticeDate} />
              </Grid>
            </Grid>
          </>
        ))}
      </div>
    </div>
  );
}
LegalNotificationDetails.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  handleChange: PropTypes.bool.isRequired,
  legalNotices: PropTypes.array.isRequired,
};
export default withStyles(styles)(injectIntl(LegalNotificationDetails));
